import router from '../../router'
import store from '../../store'

export default {
  getTypeCode (itemId) {
    return store.getters.getAssistMatterTypes().get(itemId.toUpperCase()) != null ? itemId.toUpperCase() : null
  },
  open (itemId, newWindow) {
    if (this.getTypeCode(itemId)) {
      itemId = itemId.toLowerCase()
    }
    let url = this.getItemRef(itemId)
    if (!newWindow) {
      router.push({path: url.replace('#', '')})
    } else {
      store.dispatch('openLocation', url)
    }
  },
  getItemRef (itemId) {
    return '#/assist/' + itemId
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/index.js